import React, { useEffect } from 'react';
import './ProtectedContent.css';

function ProtectedContent({ user, children }) {
  const isAdmin = user && user.role?.toLowerCase() === 'admin';
  const isRecruiter = user && ['recruiter', 'recruiting_admin'].includes(user.role?.toLowerCase());
  const isAdminOrRecruiter = isAdmin || isRecruiter;

  useEffect(() => {
    if (!isAdminOrRecruiter) {
      // Disable right-click context menu
      const handleContextMenu = (e) => {
        e.preventDefault();
        alert('Screenshot and download features are disabled for non-admin users.');
        return false;
      };

      // Detect keyboard shortcuts for screenshots
      const handleKeyDown = (e) => {
        // Cmd+Shift+3, Cmd+Shift+4 (Mac screenshots)
        // PrtScn, Alt+PrtScn (Windows screenshots)
        // Ctrl+P (Print)
        // Ctrl+S (Save)
        if (
          (e.metaKey && e.shiftKey && (e.key === '3' || e.key === '4' || e.key === '5')) ||
          e.key === 'PrintScreen' ||
          (e.ctrlKey && e.key === 'p') ||
          (e.ctrlKey && e.key === 's') ||
          (e.metaKey && e.key === 'p') ||
          (e.metaKey && e.key === 's')
        ) {
          e.preventDefault();
          alert('Screenshot and download features are disabled for non-admin users.');
          return false;
        }

        // Detect browser DevTools (F12, Ctrl+Shift+I, etc.)
        if (
          e.key === 'F12' ||
          (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J' || e.key === 'C')) ||
          (e.metaKey && e.altKey && (e.key === 'I' || e.key === 'J' || e.key === 'C'))
        ) {
          e.preventDefault();
          alert('Developer tools are disabled for non-admin users.');
          return false;
        }
      };

      // Disable text selection and copying
      const handleCopy = (e) => {
        e.preventDefault();
        alert('Copying is disabled for non-admin users.');
        return false;
      };

      // Add event listeners
      document.addEventListener('contextmenu', handleContextMenu);
      document.addEventListener('keydown', handleKeyDown);
      document.addEventListener('copy', handleCopy);

      // Add protection class to body
      document.body.classList.add('protected-content');

      // Cleanup
      return () => {
        document.removeEventListener('contextmenu', handleContextMenu);
        document.removeEventListener('keydown', handleKeyDown);
        document.removeEventListener('copy', handleCopy);
        document.body.classList.remove('protected-content');
      };
    }
  }, [isAdminOrRecruiter]);

  return (
    <div className={!isAdminOrRecruiter ? 'protected-wrapper' : ''}>
      {!isAdminOrRecruiter && (
        <div className="watermark">
          {user.email} - {new Date().toLocaleString()}
        </div>
      )}
      {children}
    </div>
  );
}

export default ProtectedContent;
